import { Box, Flex } from 'reflexbox';

import { Card, Heading, Paragraph, Skeleton, Subheading } from '@treams/treams-ui';

export function TreamsScoreAnalyticsLoading() {
	return (
		<>
			<Card style={{ overflow: 'visible' }}>
				<Heading.Skeleton width={300} mb={2} />
				<Paragraph.Skeleton width={500} lines={1} />

				<Flex
					my={4}
					flexDirection={['column', 'column', 'row']}
					alignItems={['center', 'center', 'stretch']}
					style={{ flexGrow: 1 }}
				>
					<Box px={5} width={['100%', '100%', '350px']} style={{ flexShrink: 0 }}>
						<Skeleton.Box
							style={{ width: 290, height: 290, borderRadius: '50%', margin: '0 auto' }}
						/>
					</Box>

					<Box mt={[4, 4, 0]} width="100%" pl={5} pr={3}>
						<Subheading.Skeleton mb={3} />
						<Skeleton.Repeat count={5}>
							<Skeleton.Box height={32} mb={3} />
						</Skeleton.Repeat>
					</Box>
				</Flex>
			</Card>

			<Card mt={4}>
				<Heading.Skeleton mb={3} />
				<Skeleton.Repeat count={6}>
					<Skeleton.Box height={48} mb={2} />
				</Skeleton.Repeat>
			</Card>
		</>
	);
}
